import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SurveyForm } from '../models/survey-form';
import {
  SurveyHeader,
  SurveyResult,
  SurveySummary,
} from '../models/survey-header.model';
import { Survey } from '../models/survey.model';
import { GetTranslationService } from './get-translation.service';
import { ToastMachineService } from './toast-machine.service';
import { SurveyResearchHeader } from '../models/survey-research_header';
import { NotificationModel } from '../models/notification.model';
import { ReplaySubject, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  surveyForm: SurveyForm = new SurveyForm();

  surveys: SurveyHeader[] = [];
  activeSurveys: SurveyHeader[] = [];
  surveySummary: SurveySummary;

  surveyMessage$: ReplaySubject<NotificationModel> =
    new ReplaySubject<NotificationModel>();
  constructor(
    private http: HttpClient,
    private toaster: ToastMachineService,
    private translator: GetTranslationService
  ) {}

  postSurvey(survey: Survey) {
    return new Promise((resolve, reject) => {
      this.http.post(environment.apiURL + '/survey', survey).subscribe({
        next: async (data: string) => {
          const MSG = await this.translator.getTranslate(
            'Your thoughts are important to us, thank you for rating us.'
          );
          this.toaster.toastMachine(MSG, 'primary', 3000);
          resolve(data);
        },
        error: (err) => {
          const error =
            err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  getSurvey(id: number): Promise<SurveyHeader> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiURL + '/main_survey/' + id).subscribe({
        next: (survey: SurveyHeader) => {
          resolve(survey);
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  getSurveys(): Promise<SurveyHeader[]> {
    return new Promise((resolve, reject) => {
      this.http.get(environment.apiURL + '/main_surveys').subscribe({
        next: (surveys: SurveyHeader[]) => {
          this.surveys = surveys;
          this.activeSurveys = surveys.filter(
            (survey) => survey.status === 'active'
          );
          resolve(surveys);
        },
        error: (error) => {
          reject(error);
        },
      });
    });
  }

  submitSurvey(survey: SurveyResult): Promise<SurveySummary> {
    return new Promise((resolve, reject) => {
      this.http.post(environment.apiURL + '/survey_answer', survey).subscribe({
        next: (data: SurveySummary) => {
          this.surveySummary = data;
          resolve(data);
        },
        error: (err) => {
          const error =
            err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  getSurveyByRequestId(id: number): Promise<NotificationModel> {
    return new Promise((resolve, reject) => {
      this.http
        .get(environment.apiURL + '/survey_by_request_id/' + id)
        .subscribe({
          next: (survey: NotificationModel) => {
            resolve(survey);
            this.surveyMessage$.next(survey);
          },
          error: (error) => {
            reject(error);
          },
        });
    });
  }

  getSurveyLinkCode(id: number, profileId: number): Promise<string> {
    // return new Promise((resolve, reject) => {
    //   this.http.get<string[]>(`${environment.apiURL}/main_survey/${id}/survey_link_code?profile_id=${profileId}`).pipe(
    //     catchError(err => {
    //       const error = err.error && err.error.message ? err.error.message : err.message;
    //       this.toaster.toastMachine(error, 'danger', 3000);
    //       return throwError(error);
    //     })
    //   ).subscribe({
    //     next: (data: string[]) => {
    //       resolve(data);
    //     },
    //     error: err => {
    //       reject(err); // Reject promise with the error
    //     }
    //   });
    // });

    return this.http
      .get(`${environment.apiURL}/main_survey/${id}/survey_link/${profileId}`)
      .toPromise()
      .then((data: string) => data)
      .catch();
  }
}
